// src/modules/app-views/_apps/appsindico/parkingSpots/pages/Init/components/tableColumns/typeColumn.jsx
import { Tag } from 'antd';
import translateX from 'utils/translateX';

const TYPE_COLORS = {
  covered: 'green',
  uncovered: 'orange',
  garage_box: 'blue',
};

function typeColumn(buildColumnProps, options = {}) {
  const {
    key = 'type',
    title = 'type',
    dataIndex = 'type',
    width = 130,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    render: text => {
      const color = TYPE_COLORS[text] || 'default';
      return <Tag color={color}>{translateX(text || 'unknown')}</Tag>;
    },
  };
}

export default typeColumn;
